import React from 'react';
import { Link } from 'react-router-dom';
import UnifiedFooter from '../../components/ui/UnifiedFooter';
import PublicNavigation from '../../components/ui/PublicNavigation';

const sections = [
  {
    id: 'objet',
    title: '1. Objet',
    content: (
      <p>
        Les présentes Conditions Générales de Vente (CGV) définissent les conditions dans lesquelles{' '}
        <strong>ADT EXPRESS</strong>, marque exploitée par{' '}
        <strong>TRANSIMPEX INTERNATIONAL SERVICES</strong>, SASU immatriculée au RCS de Bobigny sous le
        numéro 990 952 806, dont le siège social est situé au 34 Rue Hémet, 93300 Aubervilliers, propose
        ses services de transport, de logistique et d'import-export à ses clients. Toute commande passéeauprès d'ADT EXPRESS implique l'acceptation pleine et entière des présentes CGV.
      </p>
    ),
  },
  {
    id: 'services',title: '2. Services proposés',
    content: (
      <>
        <p className="mb-3">ADT EXPRESS propose notamment les services suivants :</p>
        <ul className="list-disc list-inside space-y-2 text-gray-700 pl-2">
          <li>Envoi de colis entre la France et l'Afrique</li>
          <li>Transport de barriques et de marchandises volumineuses</li>
          <li>Groupage maritime</li>
          <li>Livraison en Côte d'Ivoire et dans d'autres destinations africaines</li>
        </ul>
        <p className="mt-3">
          Ces services sont susceptibles d'évoluer. ADT EXPRESS se réserve le droit de modifier ou
          d'interrompre tout ou partie de ses offres sans préavis.
        </p>
      </>
    ),
  },
  {
    id: 'commande',
    title: '3. Commande',
    content: (
      <>
        <p className="mb-3">
          Toute commande est considérée comme validée après confirmation des informations fournies par le
          client, notamment :
        </p>
        <ul className="list-disc list-inside space-y-2 text-gray-700 pl-2">
          <li>La nature et la description précise des marchandises</li>
          <li>Les coordonnées complètes de l'expéditeur et du destinataire</li>
          <li>La destination de livraison</li>
          <li>Le poids et les dimensions des colis ou marchandises</li>
        </ul>
        <p className="mt-3">
          ADT EXPRESS se réserve le droit de refuser toute commande en cas d'informations incomplètes,
          inexactes ou en cas de suspicion de contenu illicite.
        </p>
      </>
    ),
  },
  {
    id: 'tarifs-paiement',
    title: '4. Tarifs et paiement',
    content: (
      <>
        <p className="mb-3">
          Les prix des prestations sont indiqués en <strong>euros (€)</strong> et peuvent varier en
          fonction du poids, du volume, de la nature des marchandises et de la destination.
        </p>
        <p className="mb-3">
          Le paiement est exigé <strong>avant expédition</strong> ou lors de la collecte des
          marchandises, selon les modalités convenues entre les parties. Aucune expédition ne sera
          effectuée sans règlement préalable ou accord écrit d'ADT EXPRESS.
        </p>
        <p>
          ADT EXPRESS se réserve le droit de modifier ses tarifs à tout moment. Les tarifs applicables
          sont ceux en vigueur au moment de la validation de la commande.
        </p>
      </>
    ),
  },
  {
    id: 'delais-livraison',title: '5. Délais de livraison',
    content: (
      <>
        <p className="mb-3">
          Les délais de livraison communiqués sont donnés à titre <strong>indicatif</strong>,
          notamment pour le transport maritime qui est soumis à des contraintes opérationnelles et
          réglementaires indépendantes de la volonté d'ADT EXPRESS.
        </p>
        <p className="mb-3">
          ADT EXPRESS ne peut être tenu responsable des retards liés :
        </p>
        <ul className="list-disc list-inside space-y-2 text-gray-700 pl-2">
          <li>Aux procédures douanières dans les pays de transit ou de destination</li>
          <li>Aux délais portuaires ou aux aléas de navigation</li>
          <li>À des cas de force majeure (grèves, intempéries, conflits, pandémies, etc.)</li>
          <li>À des retards imputables aux transporteurs partenaires</li>
        </ul>
      </>
    ),
  },
  {
    id: 'responsabilite',
    title: '6. Responsabilité',
    content: (
      <>
        <p className="mb-3">
          Le client est seul responsable du contenu de son colis ou de sa marchandise. Il garantit
          qu'il n'expédie aucun produit interdit par la législation française, européenne ou du pays
          de destination.
        </p>
        <div className="bg-red-50 border-l-4 border-red-500 pl-5 py-4 rounded-r-lg mb-4">
          <p className="font-semibold text-red-800 mb-2">Produits strictement prohibés :</p>
          <ul className="list-disc list-inside space-y-1 text-red-700 text-sm">
            <li>Armes, munitions et matériels de guerre</li>
            <li>Stupéfiants et substances illicites</li>
            <li>Produits dangereux, inflammables ou explosifs</li>
            <li>Contrefaçons et marchandises piratées</li>
            <li>Devises, billets de banque et valeurs mobilières</li>
            <li>Tout produit dont l'exportation ou l'importation est réglementée ou interdite</li>
          </ul>
        </div>
        <p className="mb-3 font-semibold text-gray-800">
          ADT EXPRESS ne peut être tenu responsable en cas de :
        </p>
        <ul className="list-disc list-inside space-y-2 text-gray-700 pl-2">
          <li>Saisie douanière résultant d'un contenu non déclaré ou illicite</li>
          <li>Perte ou détérioration liée à un défaut d'emballage imputable au client</li>
          <li>Informations incorrectes, incomplètes ou frauduleuses fournies par le client</li>
          <li>Dommages causés par la nature intrinsèque des marchandises expédiées</li>
        </ul>
      </>
    ),
  },
  {
    id: 'assurance',
    title: '7. Assurance',
    content: (
      <>
        <p className="mb-3">
          Une assurance optionnelle peut être proposée au client selon la nature et la valeur déclarée
          des marchandises. Le client est invité à se renseigner auprès d'ADT EXPRESS avant toute
          expédition.
        </p>
        <p className="mb-3">
          En l'absence de souscription à une assurance, la responsabilité d'ADT EXPRESS est limitée
          aux plafonds légaux applicables en matière de transport de marchandises.
        </p>
        <p>
          ADT EXPRESS décline toute responsabilité pour les marchandises non assurées dont la valeur
          n'a pas été préalablement déclarée et acceptée par écrit.
        </p>
      </>
    ),
  },
  {
    id: 'livraison',
    title: '8. Livraison',
    content: (
      <>
        <p className="mb-3">
          La livraison est effectuée à l'adresse indiquée par le client lors de la commande. Ilappartient au client de s'assurer de l'exactitude et de l'exhaustivité des informations de
          livraison fournies.
        </p>
        <p className="mb-3">
          En cas d'absence du destinataire lors de la livraison ou d'erreur dans l'adresse fournie,
          des <strong>frais supplémentaires</strong> de réacheminement ou de stockage pourront être
          facturés au client.
        </p>
        <p>
          ADT EXPRESS ne saurait être tenu responsable d'une non-livraison résultant d'une adresseerronée, incomplète ou d'un refus de réception par le destinataire.
        </p>
      </>
    ),
  },
  {
    id: 'reclamations',
    title: '9. Réclamations',
    content: (
      <>
        <p className="mb-3">
          Toute réclamation relative à une livraison (colis manquant, endommagé, contenu incomplet)
          doit être formulée dans un délai de <strong>48 à 72 heures</strong> après réception de la
          marchandise, par écrit à l'adresse suivante :
        </p>
        <address className="not-italic bg-gray-50 border-l-4 border-green-700 pl-5 py-4 rounded-r-lg space-y-1 text-gray-700">
          <p className="font-semibold text-gray-900">ADT EXPRESS — Service Réclamations</p>
          <p>
            Email :{' '}
            <a
              href="mailto:contact@adtexpress.fr"
              className="text-green-700 hover:text-green-900 underline"
            >
              contact@adtexpress.fr
            </a>
          </p>
          <p>34 Rue Hémet, 93300 Aubervilliers, France</p>
        </address>
        <p className="mt-3">
          Passé ce délai, aucune réclamation ne pourra être prise en compte. ADT EXPRESS s'engage à
          traiter toute réclamation recevable dans les meilleurs délais.
        </p>
      </>
    ),
  },
  {
    id: 'droit-applicable',
    title: '10. Droit applicable',
    content: (
      <>
        <p className="mb-3">
          Les présentes Conditions Générales de Vente sont soumises au <strong>droit français</strong>.
          En cas de litige relatif à leur interprétation ou à leur exécution, les parties s'engagent
          à rechercher une solution amiable avant tout recours judiciaire.
        </p>
        <p>
          À défaut d'accord amiable, tout litige sera soumis à la compétence exclusive des tribunaux
          compétents du ressort du siège social de TRANSIMPEX INTERNATIONAL SERVICES, sauf disposition
          légale contraire applicable au consommateur.
        </p>
      </>
    ),
  },
];

const CGV = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <PublicNavigation />
      <main className="flex-1">
        {/* Hero */}
        <div className="bg-green-900 text-white py-12 md:py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <p className="text-green-300 text-sm font-medium mb-2 uppercase tracking-wider">
              Informations contractuelles
            </p>
            <h1 className="text-3xl md:text-4xl font-bold">
              Conditions Générales de Vente
            </h1>
            <p className="mt-3 text-green-200 text-sm">
              ADT EXPRESS — TRANSIMPEX INTERNATIONAL SERVICES · En vigueur à compter du 1er janvier 2025
            </p>
          </div>
        </div>

        {/* Content */}
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14">
          {/* Table of contents */}
          <nav className="mb-10 p-5 bg-gray-50 rounded-xl border border-gray-200">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">
              Sommaire
            </p>
            <ol className="space-y-1">
              {sections?.map((s) => (
                <li key={s?.id}>
                  <a
                    href={`#${s?.id}`}
                    className="text-green-700 hover:text-green-900 text-sm hover:underline"
                  >
                    {s?.title}
                  </a>
                </li>
              ))}
            </ol>
          </nav>

          {/* Sections */}
          <div className="space-y-10">
            {sections?.map((s) => (
              <section key={s?.id} id={s?.id} className="scroll-mt-24">
                <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                  {s?.title}
                </h2>
                <div className="text-gray-700 leading-relaxed text-sm md:text-base">
                  {s?.content}
                </div>
              </section>
            ))}
          </div>

          {/* Back link */}
          <div className="mt-14 pt-6 border-t border-gray-200 flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-sm text-green-700 hover:text-green-900 font-medium"
            >
              ← Retour à l'accueil
            </Link>
            <Link
              to="/mentions-legales"
              className="inline-flex items-center gap-2 text-sm text-green-700 hover:text-green-900 font-medium"
            >
              Voir les mentions légales →
            </Link>
          </div>
        </div>
      </main>
      <UnifiedFooter />
    </div>
  );
};

export default CGV;
